import { createFileRoute } from '@tanstack/react-router'
import AddPage from '@/features/scenic/scenic-spots/pages/add'

export const Route = createFileRoute(
  '/_authenticated/(scenic)/scenic-spots/add'
)({
  component: AddPage,
})
